import React, { useState, useEffect } from "react";
import { TableContainer, Paper, TextField, Button } from "@mui/material";
import { Typography } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

// material-ui
import Box from "@mui/material/Box";

import { StaffuseAuth } from "../../../security/StaffuseAuth";
import SimpleTableHeader from "../../../components/Tables/SimpleTableHeader";
import SimpleTableCell from "../../../components/Tables/SimpleTableCell";
import getPhotoGroup from "../../../../functions/getPhotoGroup";
import { Get_Registers_Need_Reach_Part8_AccomTypeUpdate } from "./api/Get_Registers_Need_Reach_Part8_AccomTypeUpdate";
import { api_Reach_Part8_AccomTypeUpdate } from "./api/api_Reach_Part8_AccomTypeUpdate";

function REACH_Part8_AccomTypeUpdate() {
  const { logout } = StaffuseAuth();

  const [Registers, setRegisters] = useState([
    {
      BasicInfo: {
        First_Name: "NOT FOUND",
        Created_At: "2024-10-01",
        ProgrammeTitle: "Summer Programme",
        ProgrammeVarient: "In Person",
        ProgrammeDate: "(3rd November 2024)",
      },
      Notes: [
        {
          Note: "Arrival Departure Email Sent",
          DateTime: "2024-10-07T10:00:00Z",
        },
      ],
    },
  ]);

  useEffect(() => {
    Get_Registers_Need_Reach_Part8_AccomTypeUpdate({}, setRegisters, logout);
  }, []);

  function handleSend(e, chosenArray) {
    e.preventDefault();
    chosenArray.forEach((Attendee) => {
      let options = {
        Attendee: Attendee,
      };
      api_Reach_Part8_AccomTypeUpdate(options, logout);
    });
    console.log("-----End Send-----");
  }

  //-----------------------------Return--------------------------------------------

  return (
    <div
      style={{
        backgroundColor: "#e5e5e5",
        minHeight: "93vh",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row", // Add this line
          flexWrap: "wrap",
          justifyContent: "flex-start",
          // gap: "20px",
          // height: "100%",
        }}
      >
        <div
          name="space"
          style={{ width: "100%", height: "10px", flex: "0 1 auto" }}
        ></div>
        <Box
          component="main"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            maxWidth: "95%",
            maxHeight: "800px",
            flexGrow: 1,
            p: 1,
          }}
        >
          <Typography variant="h6" gutterBottom>
            REACH Accom Update
          </Typography>
          <button
            style={{ width: "100px" }}
            onClick={(e) => handleSend(e, Registers)}
          >
            Sync
          </button>

          <TableContainer
            component={Paper}
            sx={{
              width: "100%",
              margin: "0 auto",
              overflow: "auto",
            }}
          >
            <Table
              aria-label="simple table"
              sx={{
                border: "1px solid #e0e0e0",
                tableLayout: "fixed",
              }}
            >
              <TableHead>
                <TableRow>
                  {" "}
                  <>{SimpleTableHeader("_id")}</>
                  <>{SimpleTableHeader("Name")}</>
                  <>{SimpleTableHeader("Title")}</>
                  <>{SimpleTableHeader("Date")}</>
                  <>{SimpleTableHeader("Varient")}</>
                  <>{SimpleTableHeader("EC")}</>
                  <>{SimpleTableHeader("Submission Date")}</>
                  <>{SimpleTableHeader("SEF Stage")}</>
                  <>{SimpleTableHeader("Reach ContactID")}</>
                  <>{SimpleTableHeader("Email")}</>
                </TableRow>
              </TableHead>
              <TableBody>
                {Registers.map((Register, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor:
                        Register?.MetaData?.Archived === "Yes"
                          ? "rgba(139, 0, 0, 0.5)"
                          : Register?.MetaData?.Reserved === "Yes"
                          ? "rgba(0, 0, 139, 0.5)"
                          : Register?.MetaData?.Bursary === "Yes"
                          ? "rgba(144, 238, 144, 0.5)"
                          : "",
                      "&:hover": {
                        backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                        "& .MuiTableCell-root": {
                          padding: "8px",
                          wordWrap: "break-word",
                          overflowWrap: "break-word", // Adjust padding here to make cells smaller
                        },
                      },
                    }}
                  >
                    {" "}
                    {SimpleTableCell(Register._id)}
                    {SimpleTableCell(
                      Register?.BasicInfo?.First_Name +
                        " " +
                        Register?.BasicInfo?.Last_Name
                    )}
                    {SimpleTableCell(Register?.BasicInfo?.ProgrammeTitle)}
                    {SimpleTableCell(Register?.BasicInfo?.ProgrammeDate)}
                    {SimpleTableCell(Register?.BasicInfo?.ProgrammeVarient)}
                    {SimpleTableCell(
                      Register?.IPInfo?.EC_ID &&
                        Register?.IPInfo?.EC_ID !== "" &&
                        Register?.IPInfo?.EC_ID !== null &&
                        Register?.IPInfo?.EC_ID !== undefined
                        ? "EC Booking"
                        : "Non EC Booking"
                    )}
                    {SimpleTableCell(Register?.SEFInfo?.SEFSubmissionDate)}
                    {SimpleTableCell(Register?.SEFInfo?.SEF)}
                    {SimpleTableCell(Register?.REACH?.ContactID)}
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        padding: "8px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      <button onClick={(e) => handleSend(e, [Register])}>
                        Send
                      </button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>
    </div>
  );
}

export default REACH_Part8_AccomTypeUpdate;
